export default __webpack_public_path__ + "static/media/evo-icon.c670237b.svg";